import React from 'react'

import SimpleBar from 'simplebar-react'

import 'simplebar-react/dist/simplebar.min.css'

import style from './CategoriesList.module.css'
import { CategoryItem } from './CategoryItem/CategoryItem'

import { useAppSelector } from 'common/hooks'
import { selectCategoriesBySearch } from 'features/dashboard'

type PropsType = {}

export const CategoriesList = ({}: PropsType) => {
  const categories = useAppSelector(selectCategoriesBySearch)

  return (
    <SimpleBar className={style['simple-bar']} autoHide={false}>
      <ul className={style.list}>
        {categories.map(category => (
          <CategoryItem key={category.id} category={category} />
        ))}
      </ul>
    </SimpleBar>
  )
}
